import { createContext, useContext, useState } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
};

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(() => {
        // Check localStorage to initialize the state
        return localStorage.getItem('isLoggedIn') === 'true';
    });
    const [accessToken, setAccessToken] = useState(() => {
        // Retrieve the access token from localStorage, if it exists
        return localStorage.getItem('accessToken') || null;
    });
    const [role, setRole] = useState(() => {
        return localStorage.getItem('role') || null;
    });
    const [userId, setUserId] = useState(() => {
        return localStorage.getItem('userId') || null;
    });

    // Check after login
    const login = (token, userType, userId) => {
        setIsLoggedIn(true);
        setAccessToken(token);
        setRole(userType);
        setUserId(userId);
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('accessToken', token);
        localStorage.setItem('role', userType);
        localStorage.setItem('userId', userId);
    };

    // Check during logout
    const logout = () => {
        setIsLoggedIn(false);
        setAccessToken(null);
        setRole(null);
        setUserId(null);
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('role');
        localStorage.removeItem('userId');
    };

    return (
        <AuthContext.Provider value={{ isLoggedIn, accessToken, userId, role, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
